import styled from 'styled-components';
import PropTypes from 'prop-types';
import { UPDATED_VISITOR_WIDGET_BORDER_RADIUS } from 'conversations-visitor-experience-components/widget-dimensions/constants/dimensions';
const DragAndDropUploadOverlay = styled.div.withConfig({
  displayName: "DragAndDropUploadOverlay"
})(["position:absolute;", ";transition:background 0.2s;z-index:99;border-bottom-left-radius:", "px;border-bottom-right-radius:", "px;display:flex;justify-content:center;align-items:center;pointer-events:none;top:0;bottom:0;left:0;right:0;"], ({
  isOver
}) => isOver && `background-color: rgba(45, 62, 80, 0.3);
  backdrop-filter: blur(2px);`, UPDATED_VISITOR_WIDGET_BORDER_RADIUS, UPDATED_VISITOR_WIDGET_BORDER_RADIUS);
DragAndDropUploadOverlay.displayName = 'DragAndDropUploadOverlay';
DragAndDropUploadOverlay.propTypes = {
  isOver: PropTypes.bool.isRequired
};
export default DragAndDropUploadOverlay;